import ReactGA from "react-ga4";

const itIsProductionOrStagingEnv =
  process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging";

export function gaEvent({ category, action, label, options = {} }) {
  try {
    if (itIsProductionOrStagingEnv) {
      ReactGA.event({ category, action, label, options });
    }
  } catch (err) {
    console.log(err);
  }
}

export const triggerBlueTagConversionEvent = ({ plansId, transactionTotal, transactionId }) => {
  const loadBlueTagScript = () => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//event.getblue.io/js/blue-tag.min.js";
    script.async = true;
    script.id = "blue-tag-script";
    document.head.appendChild(script);
  };

  const removeBlueTagScript = () => {
    const script = document.getElementById("blue-tag-script");
    if (script) {
      document.head.removeChild(script);
    }
  };

  const isProduction = process.env.NODE_ENV === "production";

  if (isProduction) {
    if (isNaN(transactionTotal)) return;
    loadBlueTagScript();
    const total = transactionTotal / 100;
    window.blue_q = window.blue_q || [];
    window.blue_q.push(
      { event: "setCampaignId", value: process.env.REACT_APP_BLUE_TAG_CAMPAGN_ID },
      { event: "setProductId", value: [plansId] },
      { event: "setTransactionTotal", value: total },
      { event: "setTransactionId", value: transactionId },
      { event: "setPageType", value: "conversion" }
    );
    removeBlueTagScript();
  }
};
